export const ERROR_REQUIRED = 'is required.';
export const ERROR_EMAIL = 'That doesn’t look like a valid email';
export const ERROR_NUMBER = 'That doesn’t look like a number';
export const ERROR_FILE = 'That doesn’t look like a file';
export const ERROR_OPTION = 'Please select an option';

// @eslint-disable-next-line
export const DISAGREE_TO_SHARE_INFO =
  'I do not agree to the Whistleblowing Service or the bank receiving my personal information. I am making an anonymous report.';
